var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("StandardTableVue", {
    staticStyle: {
      width: "70%"
    },
    attrs: {
      columns: _vm.columns,
      dataSource: _vm.dataList,
      pagination: false,
      rowKey: "id",
      loading: _vm.dataLoading
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(_ref) {
        var record = _ref.record;
        return _c("span", {}, [_c("a-button", {
          attrs: {
            type: "link",
            loading: _vm.resolveErrorLoading
          },
          on: {
            click: function click($event) {
              return _vm.onResolveError(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("deploy.resolved")))])], 1);
      }
    }])
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };